export const OPTION = '/domain/option'
export const OPTION_CATEGORY = '/domain/option-category'
export const OPTION_CATEGORY_LIST = '/domain/option-category/list'
export const OPTION_SEARCH = '/domain/option/search'
